import { createActions } from 'redux-actions';

import { HealthQuoteCompare } from '@models/HealthQuote';
import { CompareHealthQuoteParams } from '@apis/HealthQuoteApi';

export type State = {
  healthQuotes?: HealthQuoteCompare[] | null;
};

export type HealthQuotesFetchPayload = CompareHealthQuoteParams;
export type StateUpdatePayload = Partial<State>;

export const {
  healthQuotesFetch,
  stateUpdate,
} = createActions(
  'HEALTH_QUOTES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'HEALTH_QUOTE_COMPARE_PAGE',
  }
);
